import { SoftphoneIntegrationEnum, TimeEnum } from '@lib/enums';

import type { AppConfig } from '@config';

export const QaConfig = {
  apiKeyGoogleMaps: 'AIzaSyB6aRjr-BiiOP2tPG4OLlcLmDl73NfhzXw',
  appEnv: 'qa',
  azure: {
    appInsightsConnectionString:
      'InstrumentationKey=a38a8a3a-7e0b-4609-9e49-8cd33e1917a5;IngestionEndpoint=https://centralus-2.in.applicationinsights.azure.com/;LiveEndpoint=https://centralus.livediagnostics.monitor.azure.com/',
    appInsightsKey: 'a38a8a3a-7e0b-4609-9e49-8cd33e1917a5',
    authority: 'https://login.microsoftonline.com/daae7bc1-c893-46c4-8df4-4464a9a6f43e',
    clientId: '1ffc00d1-10a4-4e76-8840-912239b05fee',
    tenantId: 'daae7bc1-c893-46c4-8df4-4464a9a6f43e',
  },
  gatewayUrl: 'https://end-gateway-kitt-qa.azurewebsites.net/api/v1',
  paymentUrl: 'https://enduipaymentkittqa-g7afh3cfakcaefcx.z01.azurefd.net/',
  softphoneIntegration: {
    client: SoftphoneIntegrationEnum.Contacts,
    enabled: true,
    enableDebugLogs: false,
  },
  defaultApiTimeout: TimeEnum.ThirtySeconds,
  sentryIngestionEndpoint:
    'https://4c7389d417facfc54fc63ce40581895a@o4506672688791552.ingest.sentry.io/4506672696393728',
} satisfies AppConfig;
